import { useState } from 'react';
import { RuleChange, RuleCondition } from '../../../cashflow';
import { TransactionEntryRuleFieldsFragment } from '../../../graphql/generated';
import {
    CHANGE_CONFIGS,
    CONDITION_CONFIGS,
    RuleChangeWithEnabled,
    RuleConditionWithEnabled,
} from './config';
import { RuleViewProps } from './types';

export const useFormState = ({
    rule,
    defaultConditions,
    defaultChanges,
    isGlobalRule,
}: RuleViewProps) => {
    const [conditions, setConditions] = useConditions(rule, defaultConditions);
    const [changes, setChanges] = useChanges(rule, defaultChanges);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleConditionChange = (condition: RuleConditionWithEnabled) => {
        setConditions(
            conditions.map((c) => (c.field === condition.field ? condition : c))
        );
    };

    const handleChangeChange = (change: RuleChangeWithEnabled) => {
        setChanges(changes.map((c) => (c.field === change.field ? change : c)));
    };

    const [applyToAll, setApplyToAll] = useState(!isGlobalRule);

    return {
        conditions,
        changes,
        isSubmitting,
        setIsSubmitting,
        handleConditionChange,
        handleChangeChange,
        applyToAll,
        setApplyToAll,
    };
};

const useChanges = (
    rule?: TransactionEntryRuleFieldsFragment,
    defaultChanges?: RuleChange[]
) => {
    const initialChanges = CHANGE_CONFIGS.map((config) => {
        const change = (rule?.changeset || defaultChanges || []).find(
            (c) => c.field === config.field
        );
        return change ? { ...change, enabled: true } : config.defaultValue;
    });

    return useState<RuleChangeWithEnabled[]>(initialChanges);
};

const useConditions = (
    rule?: TransactionEntryRuleFieldsFragment,
    defaultConditions?: RuleCondition[]
) => {
    const initialConditions = CONDITION_CONFIGS.map((config) => {
        const condition = (rule?.conditions || defaultConditions || []).find(
            (c) => c.field === config.field
        );
        return condition
            ? { ...condition, enabled: true }
            : config.defaultValue;
    });

    return useState<RuleConditionWithEnabled[]>(initialConditions);
};
